export default "__VITE_ASSET__XqG$Sm0F__"